import {
  Boxes, ClipboardList, Container, FileCheck, Globe, Handshake, MapPin, Package,
  Plane, Receipt, Route, Scale, ShieldCheck, Ship, Snowflake, Timer, Train, Truck,
  Warehouse, type LucideIcon,
} from 'lucide-react';

/**
 * The service-icon allowlist, as an explicit map.
 *
 * Deliberately NOT `import * as Icons from 'lucide-react'` with a dynamic
 * lookup: a namespace import defeats tree-shaking and drags the entire
 * ~1500-icon library into the main bundle, which alone blew the 200 KB budget
 * in §10.9. It also mirrors the server's allowlist — a typo'd icon name
 * renders nothing on the public site and nobody notices until a customer does.
 */
export const SERVICE_ICONS: Record<string, LucideIcon> = {
  Package, Truck, Plane, Ship, Train, Warehouse, Container,
  Globe, MapPin, Route, Timer, ShieldCheck, FileCheck, Receipt,
  Scale, Snowflake, Boxes, ClipboardList, Handshake,
};

export const SERVICE_ICON_NAMES = Object.keys(SERVICE_ICONS);

export function serviceIcon(name: string | null | undefined): LucideIcon {
  return (name && SERVICE_ICONS[name]) || Package;
}
